import { CREATE_JUDO_PAYMENT_LINK_REL } from './constants'

export const createJudoPaymentLink = (state) =>
  state.links.filter((link) => link.Rel === CREATE_JUDO_PAYMENT_LINK_REL)[0]

export const getRiskData = (state) => state.riskData

export const getPriceData = (state) => state.price
